import { NAME_SPACE } from './config';
import Accordion from './AccordionComponent.vue';

export default {
    name: NAME_SPACE,
    components: {
        'accordion-component': Accordion,
    },
};
